export default __webpack_public_path__ + "static/media/gut-health-nutrition.8109f253.png";